import React from 'react';

export default function Button({ children, variant = 'primary', className = '', ...props }) {
  const baseStyles = "inline-flex items-center justify-center px-8 py-4 text-sm tracking-widest uppercase transition-all duration-300 ease-out";
  
  const variants = {
    primary: "bg-kin-gold text-kin-black hover:bg-[#d4b27a] hover:scale-[1.02]",
    secondary: "bg-transparent border border-kin-ivory/30 text-kin-ivory hover:border-kin-gold hover:text-kin-gold",
    ghost: "bg-transparent text-kin-ivory hover:text-kin-gold"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}